export const CLOUDINARY_CLOUD_NAME = 'dg8nuyybc';
export const CLOUDINARY_UPLOAD_PRESET = 'user_profile_pictures';
